import { mainCategorySlugs } from 'util/project/project-data';
import { MAP_APP_RECORD_NAMES } from 'framework/router/route-data-configs';
import { RESOURCE_TYPES } from 'util/project/helpers';

/**
 * Navigation guard to differentiate between maincategory-only and entry-only pages
 * @param {any} to - Route record (vue-router)
 * @param {any} from - Route record (vue-router)
 * @param {function} next - Next callback
 */
export function mainCategoryOnlyRouteGuard(to, from, next) {
    const { maincategory } = to.params;
    const goesToEntryOnly = to.name === MAP_APP_RECORD_NAMES.ENTRY_ONLY;
    const hasValidMainCategory = mainCategorySlugs.includes(maincategory);

    if (goesToEntryOnly || hasValidMainCategory) {
        next();
    } else {
        next({
            name: MAP_APP_RECORD_NAMES.ENTRY_ONLY,
            params: {
                entry: maincategory,
            },
            replace: true,
        });
    }
}

/**
 * Decide which main category route to use, based on a given slug
 * @param {string} slug - The category slug
 * @param {string} type - The category type
 * @return {any} The target route
 */
export function getMainCategoryRoute({ slug, type }) {
    if (type === RESOURCE_TYPES.MAIN && slug) {
        return {
            name: MAP_APP_RECORD_NAMES.MAIN_CATEGORY_ONLY,
            params: { maincategory: slug },
        };
    }

    return {
        name: MAP_APP_RECORD_NAMES.MAP,
    };
}

/**
 * Decide which entry route to use, based on the params
 * @param {string} entry - The entry param
 * @param {string} maincategory - The main category param
 * @param {string} subcategory - The sub category param
 * @return {any} The target route
 */
export function getEntryRoute({ entry, maincategory, subcategory }) {
    if (subcategory) {
        return {
            name: MAP_APP_RECORD_NAMES.SUB_CATEGORY_ENTRY,
            params: { entry, maincategory, subcategory },
        };
    }

    if (maincategory) {
        return {
            name: MAP_APP_RECORD_NAMES.MAIN_CATEGORY_ENTRY,
            params: { entry, maincategory },
        };
    }

    return {
        name: MAP_APP_RECORD_NAMES.ENTRY_ONLY,
        params: { entry },
    };
}
